import { render } from "./Relastatsetc.vue?vue&type=template&id=b720db32&scoped=true"
import script from "./Relastatsetc.vue?vue&type=script&lang=js"
export * from "./Relastatsetc.vue?vue&type=script&lang=js"

import "./Relastatsetc.vue?vue&type=style&index=0&id=b720db32&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b720db32"]])

export default __exports__